var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaretDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CaretDown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3763 6.28318L9.06379 11.2832C8.98976 11.3531 8.90179 11.4086 8.80493 11.4464C8.70807 11.4843 8.60422 11.5038 8.49934 11.5038C8.39446 11.5038 8.29061 11.4843 8.19375 11.4464C8.09689 11.4086 8.00892 11.3531 7.93488 11.2832L2.62238 6.28318C2.47268 6.14228 2.38858 5.95118 2.38858 5.75193C2.38858 5.55267 2.47268 5.36157 2.62238 5.22068C2.77209 5.07978 2.97513 5.00063 3.18684 5.00063C3.39855 5.00063 3.60159 5.07978 3.75129 5.22068L8.5 9.69005L13.2487 5.22005C13.3984 5.07916 13.6015 5 13.8132 5C14.0249 5 14.2279 5.07916 14.3776 5.22005C14.5273 5.36095 14.6114 5.55204 14.6114 5.7513C14.6114 5.95056 14.5273 6.14165 14.3776 6.28255L14.3763 6.28318Z",
    fill: "#040742"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/CaretDown.49bdf90db4a332072ee136fa7e79c666.svg";
export { ForwardRef as ReactComponent };